export const REQUEST_SPECIFIC_GOALS = "request_specific_goals"
export const SPECIFIC_GOAL_SUCCESS = "specific_goal_success"
export const SPECIFIC_GOAL_FAILURE = "specific_goal_failure"

export const CLEAR_SPECIFIC_GOALS_STATES = "clear_specific_goals_states"